import { IRouteConfig } from '@fareye/types'
import { Flex, Grid, RenderControl } from '@fareye/ui'
import { cancelToken, get } from '@fareye/utils'
import React from 'react'
import { RouteComponentProps } from 'react-router'
import queryString from 'query-string'
import { IssueListing } from '@fareye/issue-resolution'
import Header from './components/Header'
import { parcelConfig } from './config'
import ParcelLayout from './parcelLayout'
import { TripDetailContext } from '../TripDetails'
import { getTimezone, useTimeZone, useTranslation } from '@fareye/common'

export const initialState = {
  isLoading: false,
  isError: false,
  isSuccess: true,
  message: '',
  data: null
}
interface IParcelDetails extends RouteComponentProps {
  config: any
  routesConfig?: Partial<IRouteConfig>[]
  baseUrl: string
}
export default function ParcelDetails({
  match,
  config = parcelConfig,
  history,
  location,
  routesConfig,
  baseUrl
}: IParcelDetails) {
  baseUrl = baseUrl || config?.config['timelineServiceURL']
  config = config ? config : parcelConfig
  const {
    styling: { layoutStyle, style, className }
  } = config
  const source = cancelToken().source()
  const searchParams = queryString.parse(location.search)
  const { slug }: any = match.params
  const { issueRaised, historyCount = 400 } = searchParams
  const { state } = useTimeZone()
  const [showDrawer, setShowDrawer] = React.useState(issueRaised ? true : false)
  const { t } = useTranslation()
  const [apiResponse, setApiResponse] = React.useState<any>(initialState)
  React.useEffect(() => {
    fetchData()
    return () =>
      source.cancel('Parcel Detail call cancel as Component unmounted')
  }, [slug])

  async function fetchData() {
    try {
      setApiResponse({ ...apiResponse, isLoading: true })
      const { summaryURL } = config.config
      const headers: any = {}
      if (config.config.isShared == 'true') {
        headers['X-Fe-Timezone'] = getTimezone()
      }
      const { data } = await get(`${summaryURL}${slug}`, source.token, {
        headers: {
          'Key-Inflection': 'camel',
          'X-Change-Case': true,
          ...headers
        }
      })
      setApiResponse({
        ...apiResponse,
        isLoading: false,
        isSuccess: true,
        data
      })
    } catch (ex:any) {
      setApiResponse({
        ...apiResponse,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: 'Something went wrong'
      })
    }
  }
  const shipmentNo: string = apiResponse?.data?.shipmentNo || ''
  return (
    <TripDetailContext.Provider value={{ apiResponse, setApiResponse }}>
      <Grid>
        {showDrawer && (
          <IssueListing
            showDrawer={showDrawer}
            setShowDrawer={setShowDrawer}
            resourceId={shipmentNo}
            resourceType="Shipment"
            baseUrl={''}
            updateIssueCount={() => {
              setApiResponse({
                ...apiResponse,
                data: {
                  ...apiResponse.data,
                  issuesCount: apiResponse.data.issuesCount + 1
                }
              })
            }}
            t={t}
          />
        )}
        <RenderControl state={apiResponse} variant={'xl'}>
          <Flex
            style={{ ...layoutStyle, ...style }}
            className={className}
            column
          >
            <Header
              slug={shipmentNo}
              match={match}
              config={config.config}
              history={history}
              location={location}
              routesConfig={routesConfig}
              setIssueClicked={setShowDrawer}
              breadcrumbText={'Parcel Visibility'}
              issuesCount={apiResponse?.data?.issuesCount}
            />
            <ParcelLayout
              data={apiResponse.data}
              config={config}
              location={location}
              baseUrl={baseUrl}
              match={match}
            />
          </Flex>
        </RenderControl>
      </Grid>
    </TripDetailContext.Provider>
  )
}
